import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/db73t4baskivmpnrcfgg";

const topics = ["内容建议", "资讯报错", "合作与反馈", "其他问题"];

export default function FeedbackForm() {
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setFormError("");
      setFormSuccess("提交成功，感谢你的反馈！");
      form.reset();
      return;
    }

    setFormError("");
    setFormSuccess("");
    setSubmitting(true);

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key === "website_alt") return;
        payload.append(key, String(value));
      });

      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";

      const isSpam = /spam/i.test(serverMsg);
      const codeOk = !parsed?.code || parsed.code === "OK";

      if (!response.ok || !codeOk || isSpam) {
        setFormError(serverMsg || "提交失败，请稍后重试。");
        return;
      }

      setFormSuccess("提交成功，感谢你的反馈！");
      form.reset();
    } catch {
      setFormError("网络异常，提交未成功，请稍后重试。");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      id="feedback-form-78anime"
      data-readdy-form
      onSubmit={handleSubmit}
      className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <label className="flex flex-col gap-1.5">
          <span className="text-xs font-medium text-foreground-600">称呼</span>
          <input
            type="text"
            name="name"
            required
            placeholder="请输入你的称呼"
            className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-xs font-medium text-foreground-600">邮箱</span>
          <input
            type="email"
            name="email"
            required
            placeholder="便于我们回复你"
            className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
          />
        </label>
      </div>

      <label className="mt-4 flex flex-col gap-1.5">
        <span className="text-xs font-medium text-foreground-600">反馈类型</span>
        <div className="relative">
          <select
            name="topic"
            required
            defaultValue=""
            className="w-full appearance-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 pr-9 text-sm text-foreground-900 focus:border-primary-400 focus:outline-none cursor-pointer"
          >
            <option value="" disabled>
              请选择反馈类型
            </option>
            {topics.map((topic) => (
              <option key={topic} value={topic}>
                {topic}
              </option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-lg text-foreground-400" />
        </div>
      </label>

      <label className="mt-4 flex flex-col gap-1.5">
        <span className="text-xs font-medium text-foreground-600">反馈内容</span>
        <textarea
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请描述你的建议或问题（最多 500 字）"
          className="resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
        />
      </label>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-guard-field"
      />

      {formError && (
        <p className="mt-4 flex items-center gap-2 rounded-md bg-accent-100 px-3 py-2.5 text-sm text-accent-900">
          <i className="ri-error-warning-line" />
          {formError}
        </p>
      )}
      {formSuccess && (
        <p className="mt-4 flex items-center gap-2 rounded-md bg-primary-100 px-3 py-2.5 text-sm text-primary-800">
          <i className="ri-checkbox-circle-line" />
          {formSuccess}
        </p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="mt-5 flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 cursor-pointer"
      >
        <i className={submitting ? "ri-loader-4-line animate-spin" : "ri-send-plane-line"} />
        {submitting ? "提交中..." : "提交反馈"}
      </button>
    </form>
  );
}